"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eleven/sections/workSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type WorkSection36sItem = {
    key: Key | null | undefined;
    /** Detected variants: "work-item-eleven wow fadeInUp" | "work-item-eleven two wow fadeInUp" | "work-item-eleven three wow fadeInUp" */
    className: string;
    /** Detected variants: "1s" | "2s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "Step 1" | "Step 2" | "Step 3" */
    span0Text: ReactNode;
    /** Detected variants: "At the initial stage, our experts understand your needs and recommend the best treatment." | "Our experts create a customized surgical or non surgical plan tailored to your unique needs." | "Our specialists carry out the procedure with precision, ensuring safe and effective results." */
    div0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/category/work-img-1.jpg" | "/Templates/Doccure/img/category/work-img-2.jpg" | "/Templates/Doccure/img/category/work-img-3.jpg" */
    src: string;
    /** Detected variants: "Initial Consultation" | "Treatment Planning" | "Procedure Execution" */
    h30Text: ReactNode;
    /** Detected variants: "col-lg-3 col-sm-6" */
    divClassName?: string;
    /** Detected variants: "step" */
    div0ClassName?: string;
    /** Detected variants: "fa-solid fa-circle" */
    i0ClassName?: string;
    /** Detected variants: "arrow-img" */
    div1ClassName?: string;
    /** Detected variants: "isax isax-arrow-down-1" */
    i0ClassName2?: string;
    /** Detected variants: "work-content" */
    div2ClassName?: string;
    /** Detected variants: "work-img" */
    div0ClassName2?: string;
    /** Detected variants: "text" */
    div0ClassName3?: string;
    /** Detected variants: "work" */
    alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "arrow" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid slide-arrow-icon" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/arrow-icon.png" */
    imageWithBasePath0Src?: string;
};
export type HomeElevenWorkSectionGeneratedProps = {
    divDiv0Div2Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div2H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection36sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Our Work Process" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-left.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-right.svg" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "How We Transform Your Aesthetic Goals" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1Div0ClassName?: string;
    /** Default: "4s" */
    sectionDiv0Div1Div0Div3Div0DivDataWowDuration?: string;
    /** Default: "Step 4" */
    sectionDiv0Div1Div0Div3Div0Div0Span0SpanText?: ReactNode;
    /** Default: "Our team provides continuous recovery support to ensure a comfortable healing process." */
    sectionDiv0Div1Div0Div3Div0Div2Div0Div0DivText?: ReactNode;
    /** Default: "work" */
    sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/category/work-img-4.jpg" */
    sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Recovery Support" */
    sectionDiv0Div1Div0Div3Div0Div2H30H3Text?: ReactNode;
    sectionDiv0Div1Div0Div3Div0Div2H30H3Visible?: boolean;
    sectionDiv0Div1Div0Div3Div0Div2H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div3Div0Div2H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/work-bg-one.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/work-bg-2.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/work-bg-3.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/work-bg-4.png" */
    sectionImageWithBasePath3ImageSrc?: string;
    sectionImageWithBasePath3ImageVisible?: boolean;
    sectionImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath4ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/work-shadow.png" */
    sectionImageWithBasePath4ImageSrc?: string;
    sectionImageWithBasePath4ImageVisible?: boolean;
    sectionImageWithBasePath4ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath4ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    workSection36s: WorkSection36sItem[];
    workSection36sItemWrapper?: (item: WorkSection36sItem, content: ReactNode) => ReactNode;
    workSection36sRenderer?: (defaultNode: ReactNode) => ReactNode;
    workSection36sImageVisible?: boolean;
    workSection36sImageRenderer?: (item: WorkSection36sItem, defaultNode: ReactNode) => ReactNode;
    workSection36sH3Visible?: boolean;
    workSection36sH3Renderer?: (item: WorkSection36sItem, defaultNode: ReactNode) => ReactNode;
    workSection36sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    workSection36sH3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection36sItem) => Partial<ComponentProps<"h3">>);
};

const HomeElevenWorkSectionGenerated: FC<HomeElevenWorkSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Our Work Process",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/arrow-left.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/arrow-right.svg",
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "How We Transform Your Aesthetic Goals",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div1Div0Div3Div0Div0Span0SpanText = "Step 4",
    sectionDiv0Div1Div0Div3Div0Div2Div0Div0DivText = "Our team provides continuous recovery support to ensure a comfortable healing process.",
    sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageAlt = "work",
    sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/category/work-img-4.jpg",
    sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div3Div0Div2H30H3Text = "Recovery Support",
    sectionDiv0Div1Div0Div3Div0Div2H30H3Visible,
    sectionDiv0Div1Div0Div3Div0Div2H30H3Renderer,
    sectionDiv0Div1Div0Div3Div0Div2H30H3Props,
    sectionDiv0Div1Div0Div3Div0DivDataWowDuration = "4s",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/work-bg-one.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/work-bg-2.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "bg",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/work-bg-3.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionImageWithBasePath3ImageAlt = "bg",
    sectionImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/work-bg-4.png",
    sectionImageWithBasePath3ImageVisible,
    sectionImageWithBasePath3ImageRenderer,
    sectionImageWithBasePath3ImageProps,
    sectionImageWithBasePath4ImageAlt = "bg",
    sectionImageWithBasePath4ImageSrc = "/Templates/Doccure/img/bg/work-shadow.png",
    sectionImageWithBasePath4ImageVisible,
    sectionImageWithBasePath4ImageRenderer,
    sectionImageWithBasePath4ImageProps,
    divDiv0Div2Div0ImageWithBasePath0ImageProps,
    divDiv0Div2H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0ClassName,
    workSection36s,
    workSection36sItemWrapper,
    workSection36sRenderer,
    workSection36sImageVisible,
    workSection36sImageRenderer,
    workSection36sH3Visible,
    workSection36sH3Renderer,
    workSection36sImageProps,
    workSection36sH3Props,
}) => {
    return (
        <section className="work-section-eleven section">
            <div className="container">
                <div className="section-header section-header-eleven text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid icon-1" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid icon-2" {...(sectionDiv0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                        ))}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                        </h2>
                    ))}
                </div>
                <div className="work-details-eleven">
                    <div className={sectionDiv0Div1Div0ClassName ?? "row g-5"}>
                        {renderCollectionNode(
                            workSection36s,
                            (item: WorkSection36sItem) => (
                                <div className={item.divClassName ?? "col-lg-3 col-sm-6"} key={item.key}>
                                    <div className={item.className} data-wow-duration={item.dataWowDuration}>
                                        <div className={item.div0ClassName ?? "step"}>
                                            <span>
                                                {" "}
                                                <i className={item.i0ClassName ?? "fa-solid fa-circle"} />
                                                {item.span0Text}
                                            </span>
                                        </div>
                                        <div className={item.div1ClassName ?? "arrow-img"}>
                                            <span>
                                                <i className={item.i0ClassName2 ?? "isax isax-arrow-down-1"} />
                                            </span>
                                        </div>
                                        <div className={item.div2ClassName ?? "work-content"}>
                                            {renderItemNode(workSection36sH3Visible, workSection36sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof workSection36sH3Props === "function" ? workSection36sH3Props(item) : (workSection36sH3Props ?? {}))} {...(typeof divDiv0Div2H30H3Props === "function" ? divDiv0Div2H30H3Props(item) : (divDiv0Div2H30H3Props ?? {}))}>{item.h30Text}</h3>
                                            ))}
                                            <div className={item.div0ClassName2 ?? "work-img"}>
                                                {renderItemNode(workSection36sImageVisible, workSection36sImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "work"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-one"} {...(typeof workSection36sImageProps === "function" ? workSection36sImageProps(item) : (workSection36sImageProps ?? {}))} {...(typeof divDiv0Div2Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div2Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div2Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                                <div className={item.div0ClassName3 ?? "text"}>{item.div0Text}</div>
                                            </div>
                                        </div>
                                        {renderItemNode(workSection36sImageVisible, workSection36sImageRenderer, item, (
                                            <SmartImage src={item.imageWithBasePath0Src ?? "/Templates/Doccure/img/icons/arrow-icon.png"} alt={item.imageWithBasePath0Alt ?? "arrow"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid slide-arrow-icon"} {...(typeof workSection36sImageProps === "function" ? workSection36sImageProps(item) : (workSection36sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                </div>
                            ),
                            workSection36sItemWrapper,
                            workSection36sRenderer
                        )}
                        <div className="col-lg-3 col-sm-6">
                            <div className="work-item-eleven four wow fadeInUp" data-wow-duration={sectionDiv0Div1Div0Div3Div0DivDataWowDuration}>
                                <div className="step">
                                    <span>
                                        {" "}
                                        <i className="fa-solid fa-circle" />
                                        {sectionDiv0Div1Div0Div3Div0Div0Span0SpanText}
                                    </span>
                                </div>
                                <div className="arrow-img">
                                    <span>
                                        <i className="isax isax-arrow-down-1" />
                                    </span>
                                </div>
                                <div className="work-content">
                                    {renderNode(sectionDiv0Div1Div0Div3Div0Div2H30H3Visible, sectionDiv0Div1Div0Div3Div0Div2H30H3Renderer, (
                                        <h3 className="custom-title" {...(sectionDiv0Div1Div0Div3Div0Div2H30H3Props ?? {})}>{sectionDiv0Div1Div0Div3Div0Div2H30H3Text}</h3>
                                    ))}
                                    <div className="work-img">
                                        {renderNode(sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(sectionDiv0Div1Div0Div3Div0Div2Div0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                        <div className="text">{sectionDiv0Div1Div0Div3Div0Div2Div0Div0DivText}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid work-bg-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid work-bg-two" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="img-fluid work-bg-three" {...(sectionImageWithBasePath2ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath3ImageVisible, sectionImageWithBasePath3ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath3ImageSrc} alt={sectionImageWithBasePath3ImageAlt} className="img-fluid work-bg-four" {...(sectionImageWithBasePath3ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath4ImageVisible, sectionImageWithBasePath4ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath4ImageSrc} alt={sectionImageWithBasePath4ImageAlt} className="img-fluid work-bg-five" {...(sectionImageWithBasePath4ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeElevenWorkSectionGenerated;
